function initializeEventPlannerPhone() {
	const whiteGloveService = this.formElement.querySelector('[name="white_glove_service"]:checked');
	let whiteGloveServiceValue = null;

	if (typeof whiteGloveService === 'object' && whiteGloveService !== null) {
		whiteGloveServiceValue = whiteGloveService.value;
	}

	const labelElement = this.currentStepElement.querySelector('.quote-request-event-planner-phone-number');
	const helpTextElement = this.currentStepElement.querySelector('.quote-request-event-planner-phone');
	const inputElement = this.currentStepElement.querySelector('#quote-request-event-planner-phone-number');

	if (whiteGloveServiceValue !== null && whiteGloveServiceValue === 'yes') {
		// changing the label content
		labelElement.dataset.originalText = labelElement.textContent;
		labelElement.textContent = `What's your phone number?`;

		// changing help text content
		helpTextElement.dataset.originalText = helpTextElement.textContent;
		helpTextElement.textContent = `You will receive a call from someone at GigSalad in the next 24 business hours to ask some follow-up questions.`;

		// adding required attribute to input
		inputElement.setAttribute('required', '');
	} else if (labelElement.dataset.originalText && helpTextElement.dataset.originalText) {
		labelElement.textContent = labelElement.dataset.originalText;
		helpTextElement.textContent = helpTextElement.dataset.originalText;
		inputElement.removeAttribute('required');
	}
}

export {
	initializeEventPlannerPhone
}